import React, { JSX } from 'react';
import { ServiceId } from '@/@types/application';
import { LOGO, SERVICES } from '../constants';
import Button from './Button';
import MaintenanceSchedulePosts from './MaintenanceSchedulePosts';
import Style from './MaintenanceSchedules.module.scss';
import RssButton from './RssButton';
import Section from './Section';
import Title from './Title';

// NOTE: CDNはトップに表示する必要はないが、コンパネから直リンクされているためページを用意
type ActiveServiceId = Exclude<ServiceId, 'cdn'>;
const activeServiceIds = Object.keys(SERVICES).filter((serviceId) => serviceId !== 'cdn');

const MaintenanceSchedules: React.FC = (): JSX.Element => {
  return (
    <Section>
      <Title text="メンテナンス予定">
        <RssButton href="https://www.sakura.ad.jp/rss/mainte.rdf" />
      </Title>
      {activeServiceIds.map((serviceId, i) => {
        const id = serviceId as ActiveServiceId;
        return (
          <div
            key={serviceId}
            className={Style.container}
            data-is-last={Object.keys(SERVICES).length - 1 === i ? 'true' : null}>
            <h3 className={Style.title}>
              <img src={LOGO[serviceId]} className={Style.logo} alt="" />
              {SERVICES[serviceId]}
            </h3>
            <MaintenanceSchedulePosts serviceId={id} />
          </div>
        );
      })}
      <Button text="終了したメンテナンスを見る" path="/archive/maint/" />
    </Section>
  );
};

export default MaintenanceSchedules;
